import RosterBackendService from "./RosterBackendService";

async function uploadMerchandiseCsv(fileName: string) {
  const response = await RosterBackendService.uploadMerchandiseCsv({
    fileName,
  });
  if (response.isOk()) {
    return true;
  }

  return false;
}

export default {
  uploadMerchandiseCsv,
};
